import React from 'react';
import classes from './PopUp.module.css';
var PopUp = function (_a) {
    var text = _a.text;
    return React.createElement("div", { className: classes.popUp }, text);
};
export default PopUp;
